import React, {useEffect, useState} from 'react';
import {DEFAULT_PAGE_SIZE, ODER_BY_TYPE, ORDER_BY} from "@app/constants/Common";
import TableListPaging from "@app/components/TableListPaging";
import MailTemplateListTable from "@pages/email/template/list/MailTemplateListTable";
import UpdateFullMailTemplateModal from "@pages/email/template/edit/UpdateFullMailTemplateModal";
import QuickSearchMailTemplateList from "@pages/email/template/list/QuickSearchMailTemplateList";
import UpdateSimpleMailTemplateModal from "@pages/email/template/edit/UpdateSimpleMailTemplateModal";
import {MailTempType} from "@pages/email/common/Constant";
import {requestGetInviteJobMailTemps} from "@app/services/InviteJobMailTemplateService";
import UpdateCddBriefMailTemplateModal from "@pages/email/template/edit/UpdateCddBriefMailTemplateModal";
import {ConnectCddEmpTabs} from "@pages/email/template/dvtjcuv/DVTJCUVTemplateListManager";


const InitSearch = {
    search_conditions: {},
    // mỗi phần tử gồm key column, loại sort
    sort_columns: {
        created_date_time: ORDER_BY.DESC_UPDATE_DATE
    },
}
const MailTemplateList = (props) => {
    const [templateList, setTemplateList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [selectRow, setSelectRow] = useState({});
    const [showSearchModal, setShowSearchModal] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [numberPages, setNumberPages] = useState(1);
    const [searchInput, setSearchInput] = useState(InitSearch);
    const [showAddOrEditModal, setShowAddOrEditModal] = useState(false);
    const [currentTabId, setCurrentTabId] = useState('');

    const {templateType, parentTabId, tabId} = props

    const searchMailTemplates = async (conditions) => {
        console.log("Search conditions:" + JSON.stringify(conditions))
        if (conditions) {
            searchInput.search_conditions = {...conditions}
            searchInput.search_conditions.parent_tab_id = parentTabId
            searchInput.search_conditions.sub_tab_id = tabId
            setSearchInput({...searchInput})
        }

        searchInput.search_conditions.template_type = templateType
        setShowSearchModal(false)
        setIsLoading(true)

        const res = await requestGetInviteJobMailTemps(searchInput);

        setIsLoading(false)
        const resContent = res.content
        setTotalCount(resContent.totalCount)
        const items = resContent.mail_templates.map((item, index) => {
            item.no = (resContent.page - 1) * DEFAULT_PAGE_SIZE + index + 1
            return item
        });
        setTemplateList(items);
        setNumberPages(Math.ceil(resContent.totalCount / DEFAULT_PAGE_SIZE))
    }

    useEffect(() => {
        if (tabId !== currentTabId) {
            setCurrentTabId(tabId)

            searchInput.search_conditions.parent_tab_id = parentTabId
            searchInput.search_conditions.sub_tab_id = tabId
        }
    }, [tabId])

    const onSort = async (columnKey) => {
        let sortColumns = searchInput.sort_columns
        if (sortColumns[columnKey] && sortColumns[columnKey] === ODER_BY_TYPE.ASC) {
            sortColumns[columnKey] = ODER_BY_TYPE.DESC
        } else {
            sortColumns = {}
            sortColumns[columnKey] = ODER_BY_TYPE.ASC
        }

        searchInput.sort_columns = sortColumns

        await searchMailTemplates()
    }

    useEffect(() => {
        onSort('created_date_time')
    }, []);

    const onCloseUpdateTemplate = async (reload) => {
        setShowAddOrEditModal(false)
        if (reload) {
            await searchMailTemplates()
        }
    }

    const nextPage = async () => {
        let currPage = currentPage + 1
        if (currPage <= numberPages) {
            searchInput.search_conditions.page = currPage
            await searchMailTemplates()
        } else {
            currPage = numberPages
        }
        setCurrentPage(currPage)
    };

    const backPage = async () => {
        let currPage = currentPage - 1
        if (currPage > 0) {
            searchInput.search_conditions.page = currPage
            await searchMailTemplates()
        } else {
            currPage = 0
        }
        setCurrentPage(currPage)
    };

    const onShowEditItem = (item) => {
        setSelectRow({...item})
        setShowAddOrEditModal(true)
    }

    const onShowDuplicateItem = (item) => {
        const duplicateItem = {...item}
        duplicateItem.id = ""
        setSelectRow(duplicateItem)
        setShowAddOrEditModal(true)
    }

    const onAddItem = () => {
        setSelectRow({template_type: templateType, parent_tab_id: parentTabId, sub_tab_id: currentTabId})
        setShowAddOrEditModal(true)
    }

    const getScreenTitle = () => {
        if (templateType === MailTempType.SIGNATURE) {
            return "Kho template chữ ký"
        }

        if (templateType === MailTempType.FULL) {
            return "Kho template full"
        }

        if (templateType === MailTempType.SEMI_FULL) {
            return "Kho template semi-full"
        }

        if (templateType === MailTempType.JOB_TABLE) {
            return "Kho job table info"
        }

        return "Kho template DVTJCUV"
    }

    return (
        <>
            <QuickSearchMailTemplateList onSearch={(condition) => searchMailTemplates(condition)} tabId={currentTabId}/>
            <div className="card card-default">
                <div className="card-header">
                    <h3 className="card-title text-bold mt-2">{getScreenTitle()} ({totalCount})</h3>
                    {totalCount > 0 &&
                    <h3 className='card-title text-bold ml-3 mt-2'>Page: {currentPage}/{numberPages}</h3>
                    }

                    <div className={'card-tools row'}>
                        <button type={"button"}
                                onClick={onAddItem}
                                className={'btn btn-success'}>Add
                        </button>
                        {numberPages > 1 &&
                        <div className={"mt-2 ml-2"}>
                            <TableListPaging onBack={backPage} onNext={nextPage}/>
                        </div>
                        }
                    </div>
                    {isLoading &&
                    <div className={'col-sm-12 text-center'}
                         style={{
                             position: 'absolute',
                             top: '50%',
                             left: '50%',
                             transform: 'translate(-50%, -50%)'
                         }}>
                        <div className='spinner-grow text-primary' role='status'>
                            <span className='sr-only'>Loading...</span>
                        </div>
                    </div>
                    }
                </div>
                <div className="card-body p-0">
                    <MailTemplateListTable templates={templateList}
                                           onSort={onSort}
                                           tabId={tabId}
                                           sortColumn={searchInput.sort_columns}
                                           onEditItem={(selectItem) => onShowEditItem(selectItem)}
                                           onDuplicateItem={(selectItem) => onShowDuplicateItem(selectItem)}
                                           onClose={(reload) => onCloseUpdateTemplate(reload)}/>
                </div>
            </div>
            <UpdateFullMailTemplateModal isShow={showAddOrEditModal
                        && (selectRow.template_type === MailTempType.SEMI_FULL
                || selectRow.template_type === MailTempType.FULL
                || (selectRow.template_type === MailTempType.DVTJCUV_INVITE_EMAIL && tabId !== ConnectCddEmpTabs.INVITE_CDD_BRIEF_TABLE_TAB.id)
            )}
                                         template={selectRow}
                                         onClose={(reload) => onCloseUpdateTemplate(reload)}
            />
            <UpdateSimpleMailTemplateModal isShow={showAddOrEditModal
                        && (selectRow.template_type === MailTempType.SIGNATURE || selectRow.template_type === MailTempType.JOB_TABLE)}
                                           template={selectRow}
                                           onClose={(reload) => onCloseUpdateTemplate(reload)}
            />


            <UpdateCddBriefMailTemplateModal isShow={showAddOrEditModal
            && (selectRow.template_type === MailTempType.DVTJCUV_INVITE_EMAIL && tabId === ConnectCddEmpTabs.INVITE_CDD_BRIEF_TABLE_TAB.id)}
                                         template={selectRow}
                                         onClose={(reload) => onCloseUpdateTemplate(reload)}
            />
        </>
    );
};

export default MailTemplateList;
